import { UseFormReturn } from "react-hook-form";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

export type TemplateMetadata = {
    name: string;
    isDefault: boolean;
};

export const TemplateMetadataForm = ({
    form,
    onSubmit,
    phaseLabel,
}: {
    form: UseFormReturn<TemplateMetadata>;
    onSubmit: () => void;
    phaseLabel: string;
}) => {
    return (
        <div className="w-full p-4">
            <h3 className="mb-4 text-lg font-semibold">Template Settings</h3>
            <span className="mb-4 inline-block rounded bg-blue-100 px-2 py-1 text-sm text-blue-800">
                {phaseLabel} Template
            </span>
            <Form {...form}>
                <form
                    className="space-y-4"
                    onSubmit={ev => {
                        ev.preventDefault();
                        onSubmit();
                    }}
                >
                    <FormField
                        control={form.control}
                        name="name"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Template Name</FormLabel>
                                <FormControl>
                                    <Input
                                        placeholder="Enter template name"
                                        autoComplete="off"
                                        {...field}
                                    />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name="isDefault"
                        render={({ field }) => (
                            <FormItem className="flex flex-row items-start space-x-3 space-y-0">
                                <FormControl>
                                    <Checkbox
                                        checked={field.value}
                                        onCheckedChange={field.onChange}
                                    />
                                </FormControl>
                                <div className="space-y-1 leading-none">
                                    <FormLabel>Set as Default</FormLabel>
                                    <FormDescription>
                                        This template will be used automatically when creating new
                                        tournaments
                                    </FormDescription>
                                </div>
                            </FormItem>
                        )}
                    />
                    <Button type="submit">Save Template</Button>
                </form>
            </Form>
        </div>
    );
};
